import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/homeView.vue"),
  },
  {
    path: "/qualityControl",
    name: "qualityControl",
    component: () => import("@/views/qualityControl.vue"),
  },
  {
    path: "/control",
    name: "control",
    component: () => import("@/views/control.vue"),
  },
  {
    path: "/cataLog",
    name: "cataLog",
    component: () => import("@/views/cataLog.vue"),
  },
  {
    path: "/vacuumFried",
    name: "vacuumFried",
    component: () => import("@/views/vacuumFried.vue"),
    meta: { header: "HeaderNavDep" },
  },
  {
    path: "/cooperationCase",
    name: "cooperationCase",
    component: () => import("@/views/cooperationCase.vue"),
  },
  {
    path: "/shopDetail",
    name: "shopDetail",
    component: () => import("@/views/shopDetail.vue"),
    meta: { header: "HeaderNavDep" },
  },
  {
    path: "/aboutous",
    name: "aboutous",
    component: () => import("@/views/aboutous.vue"),
  },
  {
    path: "/inspectionReport",
    name: "inspectionReport",
    component: () => import("@/views/inspectionReport.vue"),
  },
  {
    path: "/shopHome",
    name: "shopHome",
    component: () => import("@/views/shopHome.vue"),
    meta: { header: "HeaderNavDep" },
  },
  {
    path: "/rd",
    name: "rd",
    component: () => import("@/views/rd.vue"),
  },
  {
    path: "/customizedSolution",
    name: "customizedSolution",
    component: () => import("@/views/customizedSolution.vue"),
  },
  {
    path: "/freezeDried",
    name: "freezeDried",
    component: () => import("@/views/freezeDried.vue"),
    meta: { header: "HeaderNavDep" },
  },
  {
    path: "/semiDried",
    name: "semiDried",
    component: () => import("@/views/semiDried.vue"),
    meta: { header: "HeaderNavDep" },
  },
  {
    path: "/toastedDried",
    name: "toastedDried",
    component: () => import("@/views/toastedDried.vue"),
    meta: { header: "HeaderNavDep" },
  },
  // {
  //   path: "/candy",
  //   name: "candy",
  //   component: () => import("@/views/candy.vue"),
  //   meta: { header: "HeaderNavDep" },
  // },
  {
    path: "/airdired",
    name: "airdired",
    component: () => import("@/views/airdired.vue"),
    meta: { header: "HeaderNavDep" },
  },
  {
    path: "/nut",
    name: "nut",
    component: () => import("@/views/nut.vue"),
    meta: { header: "HeaderNavDep" },
  },
  {
    path: "/excessive",
    name: "excessive",
    component: () => import("@/views/excessive.vue"),
    meta: { header: "HeaderNavDep" },
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import("@/views/blog.vue"),
  },
  {
    path: "/articlesfruit",
    name: "articlesfruit",
    component: () => import("@/views/articles/fruit.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
